export const IS_PAYMENT_SCREEN_VALID = 'isPaymentScreenValid';

export type ServicePaymentQueries = {
    [IS_PAYMENT_SCREEN_VALID]: undefined;
};

export type ServicePaymentQueriesResponseType = {
    [IS_PAYMENT_SCREEN_VALID]: boolean;
};
